export var simpleAnalyticsTrack = function(eventName) {
    if (!eventName || eventName.length === 0) return;
    window && window.sa_event && window.sa_event(eventName);
};
